const searchFormsHero = document.querySelectorAll('[data-search-hero]');
const searchFormMobile = document.querySelector('[data-search-mobile]');

export default function initSearch() {
    if (searchFormsHero) {
        searchFormsHero.forEach((searchFormHero) => {
            searchFormHero.addEventListener('submit', (e) => {
                const formInput = e.target.closest('form').querySelector('input[type="search"]');

                if (!formInput.value) {
                    e.preventDefault();
                }
            });
        });
    }

    if (searchFormMobile) {
        searchFormMobile.addEventListener('submit', (e) => {
            const formInput = e.target.closest('form').querySelector('input[type="search"]');

            if (!formInput.value) {
                e.preventDefault();
            }
        });
    }
}
